import { useCallback, useState, useEffect, createContext, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'

const PremiumFeaturesContext = createContext()

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape()
  ]).isRequired
}

export const PremiumFeaturesContextProvider = ({ children }) => {
  const { session, isSessionLoaded } = useSessionContext()
  const location = useLocation()
  const navigate = useNavigate()

  const [activePremiumFeatures, setActivePremiumFeatures] = useState([])
  const [publishedPremiumFeatures, setPublishedPremiumFeatures] = useState([])
  const [tier, setTier] = useState(null)
  const [arePremiumFeaturesLoaded, setPremiumFeaturesLoaded] = useState(false)

  useEffect(() => {
    if (!isSessionLoaded) {
      return
    }
    Api.Paywall.premiumFeatures(session.dealerId)
      .then((res) => {
        setActivePremiumFeatures(res.featureCodes)
        setPublishedPremiumFeatures(res.publishedFeatures)
        setTier(res.tier)
        setPremiumFeaturesLoaded(true)
      })
      .catch(() => {
        setActivePremiumFeatures([])
        setPublishedPremiumFeatures([])
        setTier(null)
        setPremiumFeaturesLoaded(true)
      })
  }, [location.pathname, location.search, session, navigate])

  const hasAccess = useCallback((featureCode) => {
    if (arePremiumFeaturesLoaded === false || tier === 'basic' || activePremiumFeatures.length === 0) {
      return false
    }

    if (activePremiumFeatures.includes(featureCode)) {
      return true
    } else {
      return false
    }
  }, [arePremiumFeaturesLoaded]);

  const showUpgrade = useCallback((featureCode) => {
    if (arePremiumFeaturesLoaded === false || tier !== 'basic') {
      return false
    }

    if(tier === 'basic' && publishedPremiumFeatures.includes(featureCode)) {
      return true
    } else {
      return false
    }
  }, [arePremiumFeaturesLoaded]);

  return (
    <PremiumFeaturesContext.Provider value={{ hasAccess, showUpgrade, tier, arePremiumFeaturesLoaded }}>
      {children}
    </PremiumFeaturesContext.Provider>
  )
}

PremiumFeaturesContextProvider.propTypes = propTypes

export const usePremiumFeaturesContext = () => useContext(PremiumFeaturesContext)
